<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListCustomer()" isJump />
    <div>
      <el-radio-group v-model="tabPosition" size="mini">
        <el-radio-button :label="item.val" v-for="(item, index) in btnList" :key="index">
          {{ item.key }}
        </el-radio-button>
      </el-radio-group>
      <keep-alive>
        <component :is="`List${tabPosition}`" class="m-t-10" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    List1: () => import('./list-1'),
    List2: () => import('./list-2'),
    List3: () => import('./list-3')
  },
  data() {
    return {
      tabPosition: 1,
      btnList: [
        {
          key: '客户交易',
          val: 1
        },
        {
          key: '分布地区',
          val: 2
        },
        {
          key: '分布行业',
          val: 3
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
